import styled from "styled-components";

import { Typo } from "@enkor/design/components";
import { grayScale } from "@enkor/design/colors";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;

  width: 100%;
  padding: 0 44px 32px;
`;

export const Phrase = styled(Typo.Heading)`
  color: ${grayScale[700]};
  line-height: 26px;
  text-align: center;
`;
